import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import Dropdown from './../Dropdown';
import Disclaimer from '../Disclaimer';
import { view05ImageOptions } from './views/view05'

class Hull extends Component {
    constructor(props) {
        super(props);
        this.handleHullColorChange = this.handleHullColorChange.bind(this);
    }

    handleHullColorChange(newValue) {
        let configuration = this.props.configuration;
        configuration.HullColour = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
		let imageOptions = view05ImageOptions;

        let image = (
            <ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration} options={imageOptions} />
        );


        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{position:'relative'}}>
                    <h1><Trans defaults='Hull colorways' /></h1>
                    <p><Trans defaults='Bow design and integrated bow sprit as standard has been incorporated in this new version of the X4<sup>3</sup>.' /></p>
                    <Dropdown options={this.props.hullColourOptions} onChange={this.handleHullColorChange} value={this.props.configuration.HullColour} style={{ maxWidth: 472 }} />
                    <p>
                        <img style={{ border: '1px solid #c2c2c2' }} src={this.props.configuration.HullColour.preview} alt={this.props.configuration.HullColour.label} />
                    </p>
                    <h2><Trans defaults='Keel structure' /></h2>
                    <p><Trans defaults='Heat-galvanized steel keel frame improves strength, enables central lift hoist attachment and safety.' /></p>
                    <Disclaimer />
                   
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Hull);


// WEBPACK FOOTER //
// ./src/X43MK2/Hull.js